export { Footer } from './component'

// Export as default for lazy loading
export { Footer as default } from './component'
